/**
 * Scroll Animations
 * Lightweight IntersectionObserver for reveal effects.
 */

document.addEventListener('DOMContentLoaded', () => {
    // Respect reduced motion preference
    const animatedElements = document.querySelectorAll(
        '.animate-fade-up, .animate-fade-in, .animate-slide-left, .animate-slide-right, .reveal-on-scroll'
    );

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        animatedElements.forEach(el => el.classList.add('is-visible'));
        return;
    }

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.15
    };

    const handleIntersect = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);
    animatedElements.forEach(el => observer.observe(el));
});
